import React from 'react';
import BaseSubmitButton from 'components/quote_builder_widget/shared/SubmitButton';
import styles from './_style.module.scss';

const SubmitButton = ({ buttonState, onClick }) => {
  return (
    <div className={styles.formGroup} data-widget-element="form-group">
      <BaseSubmitButton
        buttonState={buttonState}
        onClick={onClick}
        buttonClassName={styles.submitButton}
      />
    </div>
  );
};

export default SubmitButton;
